<script setup lang="ts">
defineProps<{ title: string }>();
</script>

<template>
  <div class="cover-page">
    <div class="cover-content">
      <img src="@/assets/img/white-logo.svg" alt="" class="cover-logo" />
      <span class="cover-title">{{ title }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cover-page {
  width: 297mm;
  height: 210mm;
  background-color: var(--primary-dark-color);
  display: flex;
  align-items: center;
  page-break-after: always;
  overflow: hidden;

  .cover-content {
    display: flex;
    align-items: center;
    gap: 40px;
    padding-left: 40px;

    .cover-logo {
      width: 70px;
      height: 70px;
    }

    .cover-title {
      font-size: 1.5rem;
      color: var(--white-color);
    }
  }
}
</style>
